export const renderColorState = (data, title) => {
    let property = null;

    switch (title) {
        case 'par':
            property = parseInt(data.toPar, 10);
            break;
        case 'today':
            property = parseInt(data, 10);
            break;
        default:
            return property;
    }

    if (property < 0) {
        return 'is-under';
    }

    if (
        property === 0 ||
        data === 'Par' ||
        data === 'E' ||
        (data && (data.toPar === 'Par' || data.toPar === 'E'))
    ) {
        return 'is-equal';
    }

    if (property > 0) {
        return 'is-over';
    }

    return 'is-equal';
};

export const renderColorStateHoles = (holes) => {
    if (!holes.score) return false;

    let colorStateHoles = '';
    const par = holes.par;
    const score = holes.score;
    const res = score - par;

    if (res === -1) {
        colorStateHoles = 'is-under-par';
        return colorStateHoles;
    }

    if (res < -1) {
        colorStateHoles = 'is-more-under-par';
        return colorStateHoles;
    }

    if (res === 0) {
        colorStateHoles = 'is-equal';
        return colorStateHoles;
    }

    if (res > 0) {
        colorStateHoles = 'is-more-than-par';
        return colorStateHoles;
    }

    return null;
};

export const renderRoundColorState = (total, parSum) => {
    let property = null;
    let colorStateToPar = '';
    property = parseInt(total, 10);

    if (property < parSum) {
        colorStateToPar = 'is-under';
        return colorStateToPar;
    }

    if (property === parSum) {
        colorStateToPar = 'is-equal';
        return colorStateToPar;
    }

    if (property > parSum) {
        colorStateToPar = 'is-over';
        return colorStateToPar;
    }

    return colorStateToPar;
};

export const renderTotalColorState = (total, parSum1, parSum2) => {
    let property = null;
    let parSum = null;
    let colorStateToPar = '';
    property = parseInt(total, 10);
    parSum = parSum1 + parSum2;

    if (property < parSum) {
        colorStateToPar = 'is-under';
        return colorStateToPar;
    }

    if (property === parSum) {
        colorStateToPar = 'is-equal';
        return colorStateToPar;
    }

    if (property > parSum) {
        colorStateToPar = 'is-over';
        return colorStateToPar;
    }

    return colorStateToPar;
};
